// extracted by mini-css-extract-plugin
module.exports = {"courseWare":"index-courseWare-2oj0q","courseWareHeader":"index-courseWareHeader-31zpm","menulist":"index-menulist-fIqDS","light":"index-light-2mxzE"};